import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  image: {},
  placeholder: {
    backgroundColor: theme.colors.light,
    padding: '0 30%',
    objectFit: 'contain',
  },
}))

export default useStyles
